// CARAS-R: el baremo se elige por curso (no por edad) y por país. Argentina
// solo tiene 1° a 7° básico. El valor viaja como `edad` y RedPsi lo guarda
// como `baremo`.
export const CARAS_R_BAREMO_OPTIONS = [
  { value: "ES_1EP", label: "1° básico · España" },
  { value: "AR_1", label: "1° básico · Argentina" },
  { value: "ES_2EP", label: "2° básico · España" },
  { value: "AR_2", label: "2° básico · Argentina" },
  { value: "ES_3EP", label: "3° básico · España" },
  { value: "AR_3", label: "3° básico · Argentina" },
  { value: "ES_4EP", label: "4° básico · España" },
  { value: "AR_4", label: "4° básico · Argentina" },
  { value: "ES_5EP", label: "5° básico · España" },
  { value: "AR_5", label: "5° básico · Argentina" },
  { value: "ES_6EP", label: "6° básico · España" },
  { value: "AR_6", label: "6° básico · Argentina" },
  { value: "ES_1ESO", label: "7° básico · España" },
  { value: "AR_7", label: "7° básico · Argentina" },
  { value: "ES_2ESO", label: "8° básico · España" },
  { value: "ES_3ESO", label: "1° medio · España" },
  { value: "ES_4ESO", label: "2° medio · España" },
  { value: "ES_BACH", label: "3° y 4° medio · España" },
];
